import React from "react";
import { useTranslation } from "react-i18next";
import { OrangeButton } from "../../../buttons/Buttons";
import translateLDSDestinations from "../../../../services/translateLDSDestinations";
import NoResults from "../../../../assets/images/tour/tour-cover.jpg";
import { motion } from "framer-motion";

import "./tourObject.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../Routes/Routes";
import { useSelectedResult } from "../../../../contexts/SelectedResultContext";
import { Loader } from "../../../Loader/Loader";

import { MdOutlineDirectionsBus } from "react-icons/md";
import { useSearch } from "../../../../contexts/SearchContext";
import { Tooltip } from "antd/lib";
import infoSymbol from "../../../../assets/images/icons/info.svg";
import FlightSelection from "../../../FlightSelection/Index";
import { Button } from "antd";

const TourObject = (fullDeal) => {
  fullDeal = { ...fullDeal };

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSelectedResult_resetAllFields, ilsToUsd } = useSelectedResult();
  const {
    calculateLDSDealFareForRoomsComposition,
    selectedDepart,
    selectedReturn,
    linkedFlights,
  } = useSearch();

  const handleClick = () => {
    if (
      selectedDepart !== null &&
      selectedReturn !== null &&
      Array.isArray(linkedFlights)
    )
      fullDeal.linkedFlights = linkedFlights;
    setSelectedResult_resetAllFields(fullDeal);
    navigate(`/${ROUTES.TOURE_PROFILE}`);
  };

  const renderHotelData = () => {
    const { tour, isTransferIncluded, supplierDetails, hotelAllocation } =
      fullDeal;

    const supplierId = supplierDetails?.supplierId;
    // if (supplierId === "AYALA") debugger;

    const ourPrice = calculateLDSDealFareForRoomsComposition(fullDeal);
    fullDeal.ourPrice = ourPrice;

    const { ourTotalFare, ourAdultFare, ourChildFare, ourInfantFare } =
      ourPrice || {};

    // const starRating = hotel?.category?.replace(/\D/g, "");
    // const boardDetails = getBoardDetails(hotel?.board);
    const isAutoApprove = hotelAllocation === "true";
    const translatedNames = (
      Array.isArray(tour?.tourCities.val)
        ? tour?.tourCities.val
        : [tour?.tourCities.val]
    ).map((city) => translateLDSDestinations(city));

    const ourChildFareView =
      ourChildFare?.map((childFare, childIndex) => {
        return (
          <>
            <br />
            {t("packages.childPrice") +
              " " +
              (ourChildFare.length > 1
                ? (childIndex + 1).toString() + " "
                : "")}
            {childFare.priceWithCommissionAndCreditCardFee ||
              ourAdultFare.priceWithCommissionAndCreditCardFee}
            ₪
          </>
        );
      }) || [];

    return (
      <div className="hotel-data lg:tw-flex tw-flex-col lg:tw-flex-row  ">
        <img
          className="hotel-img"
          src={tour?.resourceUrl || NoResults}
          alt="טיול מאורגן"
        />
        <div className="center-hotel-data">
          <div className="hotel-name">{tour?.tourName}</div>
          <div className="hotel-city">
            {translatedNames.map((translatedName) => (
              <div>
                {translatedName.COUNTRYNAME_HEB} - {translatedName.CITYNAME_HEB}
              </div>
            ))}
          </div>

          {isTransferIncluded === "true" && (
            <div className="text-with-icon tw-text-sm lg:tw-text-base">
              <MdOutlineDirectionsBus className="orange-icon" />

              <div className="text">כולל העברות</div>
            </div>
          )}

          <div className="text-with-icon tw-text-sm lg:tw-text-base">
            <div className="text">
              {t("packages.supplierId") + ": " + supplierId}
            </div>
          </div>
        </div>
        <div className="price-data" style={{ marginBottom: "20px" }}>
          {/* todo(sagiv): Add loader*/}
          <div className="total-price">
            {ourTotalFare?.priceWithCommissionAndCreditCardFee + "₪"}{" "}
          </div>
          <div className="total-price-usd">
            {ilsToUsd(ourTotalFare?.priceWithCommissionAndCreditCardFee) + "$"}
          </div>
          <div
            className="total-title"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {t("packages.totalFare")}
            <Tooltip
              title={
                <div className="details">
                  {t("packages.passangerPrice")}{" "}
                  {ourAdultFare?.priceWithCommissionAndCreditCardFee}₪
                  {ourChildFareView}
                  {ourTotalFare?.priceWithCommissionAndCreditCardFee ? (
                    <br />
                  ) : (
                    ""
                  )}
                  {ourInfantFare?.priceWithCommissionAndCreditCardFee
                    ? t("packages.infantPrice") +
                      " " +
                      ourInfantFare?.priceWithCommissionAndCreditCardFee +
                      "₪"
                    : ""}
                </div>
              }
            >
              <img
                src={infoSymbol}
                alt="info"
                style={{
                  width: "15px",
                  height: "15px",
                  marginRight: "5px",
                }}
              />
            </Tooltip>
          </div>
          {isAutoApprove ? (
            <div className="auto-approve"> {t("packages.autoApprove")}</div>
          ) : (
            <div className="not-auto-approve">נדרש אישור של המלון</div>
          )}
          <div className="order-btn">
            <motion.div
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 4px 20px rgba(250,140,22,0.2)",
              }}
              whileTap={{ scale: 0.97 }}
              style={{ width: "100%" }}
            >
              <Button
                type="primary"
                style={{
                  width: "100%",
                  backgroundColor: "#fa8c16",
                  color: "#fff",
                  borderColor: "#fa8c16",
                  transition: "box-shadow 0.2s, transform 0.2s",
                }}
                onClick={handleClick}
              >
                {t("packages.order")}
              </Button>
            </motion.div>
          </div>
        </div>
        <FlightSelection
          linkedFlightsData={fullDeal.linkedFlights}
          loadingLinkedFlights={false}
          inTourObject={true}
          isCompact={true}
        />
      </div>
    );
  };

  return (
    <div className="package-wrapper hover:tw-bg-slate-200 md:tw-h-full tw-grid-cols-1">
      {!fullDeal ? <Loader size="small" /> : <>{renderHotelData()}</>}
    </div>
  );
};

export default TourObject;
